export default {
  getUserInfo: '/Admin/getMenu', // 获取用户信息
  getBasicData: '/BasicData/getStatisticalInfo', // 获取首页basicData
  getBasicInfo: '/BasicData/getBasicInfo', // 获取基础信息，学科、年级等
  getCoursewareInfo: '/foreign/getCoursewareInfo', // 预览获取课件详情
  getProductionType: '/TemplateStatistic/getProductionType'//获取页面生产方式
}



// WEBPACK FOOTER //
// ./src/api/common.js